/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Product Recall API
 * API pour la gestion des rappels de produits défectueux
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  BasketballHoop,
  ConcernedDto,
  CrankQuantityDto,
  EmailConfirmationDto,
  EmailConfirmationResponseDto,
  KitRequestDto,
  NotConcernedDto,
  OwnerChangedDto,
  ProductQuantityDto,
  Sd500Emd500e,
  UnknownNewOwnerDto,
} from './models'

import { customInstance } from '../mutators/axios-instance'
export const appControllerGetHello = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/`, method: 'GET', signal })
}

export const getAppControllerGetHelloQueryKey = () => {
  return [`/`] as const
}

export const getAppControllerGetHelloQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHello>>> = ({ signal }) =>
    appControllerGetHello(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetHello>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerGetHelloQueryResult = NonNullable<
  Awaited<ReturnType<typeof appControllerGetHello>>
>
export type AppControllerGetHelloQueryError = unknown

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAppControllerGetHelloQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Creates a new basketball hoop recall entry for email confirmation step. Only email and country are required.
 * @summary Create email confirmation basketball hoop recall
 */
export const basketballHoopControllerCreateEmailConfirmation = (
  emailConfirmationDto: EmailConfirmationDto,
  signal?: AbortSignal,
) => {
  return customInstance<EmailConfirmationResponseDto>({
    url: `/basketball-hoop/email-confirmation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailConfirmationDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateEmailConfirmationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>,
    TError,
    { data: EmailConfirmationDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>,
  TError,
  { data: EmailConfirmationDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateEmailConfirmation']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>,
    { data: EmailConfirmationDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateEmailConfirmation(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateEmailConfirmationMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>
>
export type BasketballHoopControllerCreateEmailConfirmationMutationBody = EmailConfirmationDto
export type BasketballHoopControllerCreateEmailConfirmationMutationError = void

/**
 * @summary Create email confirmation basketball hoop recall
 */
export const useBasketballHoopControllerCreateEmailConfirmation = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>,
      TError,
      { data: EmailConfirmationDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateEmailConfirmation>>,
  TError,
  { data: EmailConfirmationDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateEmailConfirmationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for owner change step. Email, name, phone and country are required.
 * @summary Create owner changed basketball hoop recall
 */
export const basketballHoopControllerCreateOwnerChanged = (
  ownerChangedDto: OwnerChangedDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/owner-changed`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ownerChangedDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateOwnerChangedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>,
    TError,
    { data: OwnerChangedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>,
  TError,
  { data: OwnerChangedDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateOwnerChanged']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>,
    { data: OwnerChangedDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateOwnerChanged(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateOwnerChangedMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>
>
export type BasketballHoopControllerCreateOwnerChangedMutationBody = OwnerChangedDto
export type BasketballHoopControllerCreateOwnerChangedMutationError = void

/**
 * @summary Create owner changed basketball hoop recall
 */
export const useBasketballHoopControllerCreateOwnerChanged = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>,
      TError,
      { data: OwnerChangedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateOwnerChanged>>,
  TError,
  { data: OwnerChangedDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateOwnerChangedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for not concerned users. Only email and country are required.
 * @summary Create not concerned basketball hoop recall
 */
export const basketballHoopControllerCreateNotConcerned = (
  notConcernedDto: NotConcernedDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/not-concerned`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: notConcernedDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateNotConcernedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>,
    TError,
    { data: NotConcernedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>,
  TError,
  { data: NotConcernedDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateNotConcerned']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>,
    { data: NotConcernedDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateNotConcerned(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateNotConcernedMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>
>
export type BasketballHoopControllerCreateNotConcernedMutationBody = NotConcernedDto
export type BasketballHoopControllerCreateNotConcernedMutationError = void

/**
 * @summary Create not concerned basketball hoop recall
 */
export const useBasketballHoopControllerCreateNotConcerned = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>,
      TError,
      { data: NotConcernedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateNotConcerned>>,
  TError,
  { data: NotConcernedDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateNotConcernedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for concerned users. All requestor fields are required.
 * @summary Create concerned basketball hoop recall
 */
export const basketballHoopControllerCreateConcerned = (
  concernedDto: ConcernedDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/concerned`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: concernedDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateConcernedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>,
    TError,
    { data: ConcernedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>,
  TError,
  { data: ConcernedDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateConcerned']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>,
    { data: ConcernedDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateConcerned(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateConcernedMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>
>
export type BasketballHoopControllerCreateConcernedMutationBody = ConcernedDto
export type BasketballHoopControllerCreateConcernedMutationError = void

/**
 * @summary Create concerned basketball hoop recall
 */
export const useBasketballHoopControllerCreateConcerned = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>,
      TError,
      { data: ConcernedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateConcerned>>,
  TError,
  { data: ConcernedDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateConcernedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for unknown new owner. Email, name, phone and country are required (no newOwner field).
 * @summary Create unknown new owner basketball hoop recall
 */
export const basketballHoopControllerCreateUnknownNewOwner = (
  unknownNewOwnerDto: UnknownNewOwnerDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/unknown-new-owner`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unknownNewOwnerDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateUnknownNewOwnerMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>,
    TError,
    { data: UnknownNewOwnerDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>,
  TError,
  { data: UnknownNewOwnerDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateUnknownNewOwner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>,
    { data: UnknownNewOwnerDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateUnknownNewOwner(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateUnknownNewOwnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>
>
export type BasketballHoopControllerCreateUnknownNewOwnerMutationBody = UnknownNewOwnerDto
export type BasketballHoopControllerCreateUnknownNewOwnerMutationError = void

/**
 * @summary Create unknown new owner basketball hoop recall
 */
export const useBasketballHoopControllerCreateUnknownNewOwner = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>,
      TError,
      { data: UnknownNewOwnerDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateUnknownNewOwner>>,
  TError,
  { data: UnknownNewOwnerDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateUnknownNewOwnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for crank quantity. Email, name, phone, country and crank quantities are required.
 * @summary Create crank quantity basketball hoop recall
 */
export const basketballHoopControllerCreateCrankQuantity = (
  crankQuantityDto: CrankQuantityDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/crank-quantity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: crankQuantityDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateCrankQuantityMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>,
    TError,
    { data: CrankQuantityDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>,
  TError,
  { data: CrankQuantityDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateCrankQuantity']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>,
    { data: CrankQuantityDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateCrankQuantity(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateCrankQuantityMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>
>
export type BasketballHoopControllerCreateCrankQuantityMutationBody = CrankQuantityDto
export type BasketballHoopControllerCreateCrankQuantityMutationError = void

/**
 * @summary Create crank quantity basketball hoop recall
 */
export const useBasketballHoopControllerCreateCrankQuantity = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>,
      TError,
      { data: CrankQuantityDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateCrankQuantity>>,
  TError,
  { data: CrankQuantityDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateCrankQuantityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new basketball hoop recall entry for kit request. All requestor fields (email, name, phone, country, address) and crank quantities are required.
 * @summary Create kit request basketball hoop recall
 */
export const basketballHoopControllerCreateKitRequest = (
  kitRequestDto: KitRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<BasketballHoop>({
    url: `/basketball-hoop/kit-request`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: kitRequestDto,
    signal,
  })
}

export const getBasketballHoopControllerCreateKitRequestMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>,
    TError,
    { data: KitRequestDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>,
  TError,
  { data: KitRequestDto },
  TContext
> => {
  const mutationKey = ['basketballHoopControllerCreateKitRequest']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>,
    { data: KitRequestDto }
  > = props => {
    const { data } = props ?? {}

    return basketballHoopControllerCreateKitRequest(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BasketballHoopControllerCreateKitRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>
>
export type BasketballHoopControllerCreateKitRequestMutationBody = KitRequestDto
export type BasketballHoopControllerCreateKitRequestMutationError = void

/**
 * @summary Create kit request basketball hoop recall
 */
export const useBasketballHoopControllerCreateKitRequest = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>,
      TError,
      { data: KitRequestDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof basketballHoopControllerCreateKitRequest>>,
  TError,
  { data: KitRequestDto },
  TContext
> => {
  const mutationOptions = getBasketballHoopControllerCreateKitRequestMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for email confirmation step. Only email and country are required.
 * @summary Create email confirmation SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateEmailConfirmation = (
  emailConfirmationDto: EmailConfirmationDto,
  signal?: AbortSignal,
) => {
  return customInstance<EmailConfirmationResponseDto>({
    url: `/sd500-emd500e/email-confirmation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailConfirmationDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateEmailConfirmationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>,
    TError,
    { data: EmailConfirmationDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>,
  TError,
  { data: EmailConfirmationDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateEmailConfirmation']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>,
    { data: EmailConfirmationDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateEmailConfirmation(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateEmailConfirmationMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>
>
export type Sd500Emd500eControllerCreateEmailConfirmationMutationBody = EmailConfirmationDto
export type Sd500Emd500eControllerCreateEmailConfirmationMutationError = void

/**
 * @summary Create email confirmation SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateEmailConfirmation = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>,
      TError,
      { data: EmailConfirmationDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateEmailConfirmation>>,
  TError,
  { data: EmailConfirmationDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateEmailConfirmationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for owner change step. Email, name, phone and country are required.
 * @summary Create owner changed SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateOwnerChanged = (
  ownerChangedDto: OwnerChangedDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/owner-changed`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ownerChangedDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateOwnerChangedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>,
    TError,
    { data: OwnerChangedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>,
  TError,
  { data: OwnerChangedDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateOwnerChanged']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>,
    { data: OwnerChangedDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateOwnerChanged(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateOwnerChangedMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>
>
export type Sd500Emd500eControllerCreateOwnerChangedMutationBody = OwnerChangedDto
export type Sd500Emd500eControllerCreateOwnerChangedMutationError = void

/**
 * @summary Create owner changed SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateOwnerChanged = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>,
      TError,
      { data: OwnerChangedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateOwnerChanged>>,
  TError,
  { data: OwnerChangedDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateOwnerChangedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for not concerned users. Only email and country are required.
 * @summary Create not concerned SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateNotConcerned = (
  notConcernedDto: NotConcernedDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/not-concerned`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: notConcernedDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateNotConcernedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>,
    TError,
    { data: NotConcernedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>,
  TError,
  { data: NotConcernedDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateNotConcerned']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>,
    { data: NotConcernedDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateNotConcerned(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateNotConcernedMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>
>
export type Sd500Emd500eControllerCreateNotConcernedMutationBody = NotConcernedDto
export type Sd500Emd500eControllerCreateNotConcernedMutationError = void

/**
 * @summary Create not concerned SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateNotConcerned = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>,
      TError,
      { data: NotConcernedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateNotConcerned>>,
  TError,
  { data: NotConcernedDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateNotConcernedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for concerned users. All requestor fields are required.
 * @summary Create concerned SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateConcerned = (
  concernedDto: ConcernedDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/concerned`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: concernedDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateConcernedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>,
    TError,
    { data: ConcernedDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>,
  TError,
  { data: ConcernedDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateConcerned']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>,
    { data: ConcernedDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateConcerned(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateConcernedMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>
>
export type Sd500Emd500eControllerCreateConcernedMutationBody = ConcernedDto
export type Sd500Emd500eControllerCreateConcernedMutationError = void

/**
 * @summary Create concerned SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateConcerned = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>,
      TError,
      { data: ConcernedDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateConcerned>>,
  TError,
  { data: ConcernedDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateConcernedMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for unknown new owner. Email and country are required (no newOwner field).
 * @summary Create unknown new owner SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateUnknownNewOwner = (
  unknownNewOwnerDto: UnknownNewOwnerDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/unknown-new-owner`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unknownNewOwnerDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateUnknownNewOwnerMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>,
    TError,
    { data: UnknownNewOwnerDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>,
  TError,
  { data: UnknownNewOwnerDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateUnknownNewOwner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>,
    { data: UnknownNewOwnerDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateUnknownNewOwner(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateUnknownNewOwnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>
>
export type Sd500Emd500eControllerCreateUnknownNewOwnerMutationBody = UnknownNewOwnerDto
export type Sd500Emd500eControllerCreateUnknownNewOwnerMutationError = void

/**
 * @summary Create unknown new owner SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateUnknownNewOwner = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>,
      TError,
      { data: UnknownNewOwnerDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateUnknownNewOwner>>,
  TError,
  { data: UnknownNewOwnerDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateUnknownNewOwnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for product quantity. Requestor info and at least one product quantity are required.
 * @summary Create product quantity SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateProductQuantity = (
  productQuantityDto: ProductQuantityDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/product-quantity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productQuantityDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateProductQuantityMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>,
    TError,
    { data: ProductQuantityDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>,
  TError,
  { data: ProductQuantityDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateProductQuantity']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>,
    { data: ProductQuantityDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateProductQuantity(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateProductQuantityMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>
>
export type Sd500Emd500eControllerCreateProductQuantityMutationBody = ProductQuantityDto
export type Sd500Emd500eControllerCreateProductQuantityMutationError = void

/**
 * @summary Create product quantity SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateProductQuantity = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>,
      TError,
      { data: ProductQuantityDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateProductQuantity>>,
  TError,
  { data: ProductQuantityDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateProductQuantityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * Creates a new SD500 / EMD500E recall entry for kit request. All requestor fields and product quantities are required.
 * @summary Create kit request SD500 / EMD500E recall
 */
export const sd500Emd500eControllerCreateKitRequest = (
  kitRequestDto: KitRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<Sd500Emd500e>({
    url: `/sd500-emd500e/kit-request`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: kitRequestDto,
    signal,
  })
}

export const getSd500Emd500eControllerCreateKitRequestMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>,
    TError,
    { data: KitRequestDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>,
  TError,
  { data: KitRequestDto },
  TContext
> => {
  const mutationKey = ['sd500Emd500eControllerCreateKitRequest']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>,
    { data: KitRequestDto }
  > = props => {
    const { data } = props ?? {}

    return sd500Emd500eControllerCreateKitRequest(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type Sd500Emd500eControllerCreateKitRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>
>
export type Sd500Emd500eControllerCreateKitRequestMutationBody = KitRequestDto
export type Sd500Emd500eControllerCreateKitRequestMutationError = void

/**
 * @summary Create kit request SD500 / EMD500E recall
 */
export const useSd500Emd500eControllerCreateKitRequest = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>,
      TError,
      { data: KitRequestDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sd500Emd500eControllerCreateKitRequest>>,
  TError,
  { data: KitRequestDto },
  TContext
> => {
  const mutationOptions = getSd500Emd500eControllerCreateKitRequestMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
